// A workspace theme by ID from workspace metadata. Moved from Insights/utils.js.
export const getWorkspaceTheme = (themeID, workspaceMetadata) => {
    let th = undefined
    workspaceMetadata?.themes.forEach((t) => {
        if (t.themeID === themeID) th = t
    })
    return th
}
